define([
    'backbone',
    'handlebars',
    'modules/common/views/baseview',
    'modules/common/models/auth',
    'modules/common/templates/login.html',
    'appcontext'
], (Backbone, Handlebars, BaseView, AuthModel, Template, appContext) => BaseView.extend({
    template: Handlebars.compile(Template),
    backRouteName: 'home',
    className: 'modal hide',
    attributes: {
        tabindex: -1,
        role: 'dialog',

        // z-index for overlapping spinner
        style: 'width: 270px; margin-left: -140px; z-index: 2147483647;',
        'data-backdrop': 'static',
        'data-keyboard': false
    },

    events: {
        'click .btn.login': 'submitCredentials',
        'keyup input': 'handleKey'
    },

    handleKey (event) {
        if (event.keyCode === 13) {
            this.submitCredentials();
        }
    },

    fields: ['email', 'password', 'message'],

    initialize () {
        this.model = new AuthModel();
    },

    submitCredentials () {
        this.clearErrorFields();
        this.parse_form(this.model.attributes);

        const self = this;
        const remember = this.model.get('remember');
        const ttlDays = remember ? 30 : 1;

        this.model.set({ttl: ttlDays * 24}, {silent: true});
        this.model.save(this.model.attributes, {
            success () {
                const cookieOptions = {path: '/'};
                if (remember) {
                    cookieOptions.expires = ttlDays;
                }
                appContext.setAuthToken(self.model.get('token'), cookieOptions);

                appContext.fetchUser().
                    then(() => {
                        self.deferred.resolve();
                        self.$el.modal('hide');
                    });
            },
            error (model, response) {
                self.handleErrors(model, response);
            }
        });
    },

    render () {
        const self = this;
        const user = appContext.user();
        const data = {email: user ? user.get('email') : ''};

        $(this.el).html(this.template(data));
        this.$el.modal({show: false}).bind('shown', function () {
            $(this).find('input#password').
                focus();
        }).
            bind('hide', () => {
                if (self.deferred.state() === 'pending') {
                    self.deferred.reject();
                }
            });

        return this;
    },

    execute () {
        this.deferred = $.Deferred();
        this.render().$el.modal('show');
        return this.deferred.promise();
    }
}));
